export const MAIN_CURRENCIES = '/api/currency/v1/main_currencies/';
export const CURRENCY = '/api/currency/v1/currency/';
export const USER_CURRENCY = '/api/currency/v1/user_currency/';
